import React, { useState } from "react";
import DragDropFile from "../../../UI/DragDropFile";
import { Spinner } from "reactstrap";
import { fileIconPath, headers, URL } from "../../../utils/Constants";
import swal from "sweetalert";
import { axiosPost } from "../../../utils/AxiosApi";
import { displayErrorAlert } from "../../../utils/Utils";
import axios from "axios";

const ImportCalendarEventsModal = ({
  getCalendarEvents,
  handleImportDataModal,
}) => {
  const [loading, setLoading] = useState(false);
  const [calendarFile, setCalendarFile] = useState(null);
  const [iconPreview, setIconPreview] = useState(null);
  const [fileName, setFileName] = useState(null);

  const generateFormat = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        URL.generateCalendarFormat,
        {},
        {
          headers: headers,
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const a = document.createElement("a");
        a.href = url;
        a.download = "CalendarEvents.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);

        setLoading(false);
        return;
      }
    } catch (error) {
      displayErrorAlert(error.message);
      setLoading(false);
      return;
    }
  };

  const handleChange = (e) => {
    let files = e.target.files[0];
    let icon;
    let fileName;
    if (!!files) {
      const extension = files.name.split(".").pop().toLowerCase();
      const isFileSupported = extension.match(/(xlsx|xls)/);
      if (fileIconPath[extension] && !!isFileSupported) {
        icon = fileIconPath[extension];
        fileName = files.name;
        setCalendarFile(files);
      } else {
        icon = fileIconPath.default;
        fileName = fileName =
          files.name + " appears to be in a format that is not supported.";
        setCalendarFile(null);
      }
      setFileName(fileName);
      setIconPreview(icon);
    } else {
      setFileName(null);
      setIconPreview(null);
      setCalendarFile(null);
    }
  };

  const handleFileDrop = (e, name) => {
    let files = e.dataTransfer.files[0];
    let icon;
    let fileName;
    if (files.length > 1) {
      swal("Oops", "Please select only one file");
    } else {
      if (!!files) {
        const extension = files.name.split(".").pop().toLowerCase();
        const isFileSupported = extension.match(/(xlsx|xls)/);
        if (fileIconPath[extension] && !!isFileSupported) {
          icon = fileIconPath[extension];
          fileName = files.name;
          setCalendarFile(files);
        } else {
          icon = fileIconPath.default;
          fileName = fileName =
            files.name + " appears to be in a format that is not supported.";
          setCalendarFile(null);
        }
        setFileName(fileName);
        setIconPreview(icon);
      } else {
        setFileName(null);
        setIconPreview(null);
        setCalendarFile(null);
      }
    }
  };

  const importFile = () => {
    let formData = new FormData();
    if (calendarFile !== null) {
      formData.append("file", calendarFile);

      setLoading(true);

      axiosPost(
        URL.importCalendarEvents,
        formData,
        (response) => {
          if (response.status === 200) {
            setCalendarFile(null);
            setFileName(null);
            setIconPreview(null);
            setLoading(false);
            swal("Success", "Calendar Events imported successfully.");
          }
          handleImportDataModal();
          getCalendarEvents();
        },
        (err) => {
          swal("Oops!", err.response.data.message);

          setLoading(false);
        }
      );
    } else {
      swal("Info", "Empty file cannot be imported");
    }
  };

  return (
    <>
      {loading ? (
        <div className="fullWindow-Spinner">
          <div>
            <Spinner color="white"></Spinner>
          </div>
          <div style={{ fontSize: "16px", marginTop: "15px" }}>
            Please wait...
          </div>
        </div>
      ) : null}

      <div className="container">
        <div className="d-flex justify-content-between py-2 align-items-center">
          <div className="">
            To import the calendar events data, the format should be according
            to the system. Please do not change the content of the file.
            <br /> Generate the calendar events format here.
            <br />
            <span className="text-danger font-italic">
              [Note: All columns in the file are mandatory and all date should be in AD format.]
            </span>
          </div>
          {
            <button
              className="tt-button tt-button-primary"
              onClick={generateFormat}
            >
              Generate Format
            </button>
          }
        </div>
        <div className="py-2">
          <DragDropFile
            multiple={false}
            handleChange={(e) => handleChange(e)}
            name="calendarFile"
            handleFileDrop={handleFileDrop}
            files={calendarFile}
            accept=".xlsx, .xls"
            iconPreview={iconPreview}
            fileName={fileName}
            id="calendarFile"
          />
          <div className="mt-3 text-right">
            <button
              className="tt-button tt-button-primary"
              onClick={importFile}
            >
              Import
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ImportCalendarEventsModal;
